import script from "./TextInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=45af04cc&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45af04cc"]])

export default __exports__